import { Injectable, signal, computed } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
}

const DEFAULT_DURATION_MS = 3500;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messages = signal<ToastMessage[]>([]);
  private nextId = 0;
  private timeouts: Map<number, ReturnType<typeof setTimeout>> = new Map();

  readonly toasts = this.messages.asReadonly();

  show(message: string, type: ToastType = 'success', durationMs = DEFAULT_DURATION_MS): void {
    const id = ++this.nextId;
    this.messages.update((list) => [...list, { id, message, type }]);

    const t = setTimeout(() => {
      this.dismiss(id);
      this.timeouts.delete(id);
    }, durationMs);
    this.timeouts.set(id, t);
  }

  success(message: string, durationMs?: number): void {
    this.show(message, 'success', durationMs);
  }

  dismiss(id: number): void {
    const t = this.timeouts.get(id);
    if (t) clearTimeout(t);
    this.timeouts.delete(id);
    this.messages.update((list) => list.filter((m) => m.id !== id));
  }
}
